import { motion } from 'framer-motion'
import React from 'react'
import { Link } from 'react-router-dom'
import { PageAnimation } from '../utils/PageAnimation'
import PageNotFound from '../SvgIcons/PageNotFound.svg'


const EmptyOrder = () => {
    return (
        <motion.div className="flex mt-14 flex-col justify-center items-center"initial='in' animate='out' exit='exit' 
                        variants={PageAnimation} transition={{ duration: 0.5 }}>
            <img className="w-auto md:w-1/3" src={PageNotFound} alt=""/>
            <Link to="/"  
                className="px-6 py-2 rounded-full text-white font-bold tracking-wider btn-primary">
                Go Back To Home
            </Link>
        </motion.div>
    )
}

export default EmptyOrder
